import React, { Dispatch, PropsWithChildren, SetStateAction, createContext, memo, useContext, useState } from 'react'
import { IContactedBy } from '../components/LeftPanel/filters/ContactedBy';
import { ApplicantsToggle } from '@/types/api-response';

type Props = {}

export interface IContactInfoValues {
  has_verified_email?: 0 | 1;
  has_verified_phone?: 0 | 1;
  has_no_contact_info?: 0 | 1;
}

export interface IFunctionValues {
  functions: string[],
  roles: string[]
}

export interface IInitialFilterState {
  sort_by?:any
  ipi?:string|number
  cpc?:string,
  from?: number,
  size?: number,
  sort_by_profile_ranking_score?: boolean,
  contactedBy?: number[],
  responseType?: string[],
  contactedWithin?: {
    start_date?: string,
    end_date?: string,
  },
  shortlistedWithin?: {
    start_date?: string,
    end_date?: string,
  },
  currentState?: number[],
  downloadStatus?: number[],
  currentDesignation?: string[],
  currentCompany?: string[],
  experience?: {
    max_exp?: number,
    min_exp?: number
  },
  salary?: {
    max_ctc?: number,
    min_ctc?: number,
    currency_code?: string
  }
  preferredIndustries?: string[],
  gender?: string,
  age?: {
    min_age?: number,
    max_age?: number
  },
  location?: {
    location_enabled?: boolean,
    current_location?: string[],
    preferred_location?: string[],
    curr_and_pref_loca_condition?: string
  },
  contactInfo?: IContactInfoValues,
  emailCampaign?: number[],
  shortlistedBy?: number[],
  apiProfileFlag?: number,
  applicatnsToggle?:ApplicantsToggle
  queries?: string,
  functions?: IFunctionValues[],
  is_preferred_designations?:boolean,
  designations?:string[],
  designations_categories?:string[],
  designations_scope?:string 
  "Good To Have Skills"?:string[],
  "Must Have Skills"?:string[],
  joinCondition?:string,
  "onlyTop"?: boolean,
      "onlyNonExported"?: boolean
}

export const initialFilterState: IInitialFilterState = {}

const FilterContext = createContext<[
  IInitialFilterState,
  Dispatch<SetStateAction<IInitialFilterState>>
]>([initialFilterState, () => null])

const FilterProvider = memo((props: PropsWithChildren<Props>) => {
  const [state, setState] = useState<IInitialFilterState>(initialFilterState);

  return (
    <FilterContext.Provider value={[state, setState]}>
      {props.children}
    </FilterContext.Provider>
  )
})

export default FilterProvider
export const useFilterContext = () => useContext(FilterContext);
